import { FormInstance } from "antd";

export interface AccessPointOption {
  id: number;
  description: string;
}

export interface Antenna {
  [key: string]: any;
}

export interface UpdateReaderAntennasParams {
  modelId: number;
  accessPointOptionsReader: AccessPointOption[];
  formAntenna: FormInstance;
  readersUpdateFormAntenna: (values: any) => void;
}

export const handleExcludeAntenna = (
  index: number,
  collapseKey: string,
  setActiveCollapseKeys: (value: React.SetStateAction<string[]>) => void,
  readersRemoveAntenna: (...args: any[]) => void,
  formAntenna: FormInstance<any>
) => {
  setActiveCollapseKeys((keys) => keys.filter((key) => key !== collapseKey));
  const currentAntennas = formAntenna.getFieldValue("antennas") || [];
  const currentAntenna = currentAntennas[index] || {};

  const nextAntennas = [...currentAntennas];
  nextAntennas[index] = {
    _slotIndex: currentAntenna._slotIndex,
    modelDescription: currentAntenna.modelDescription,
  };

  formAntenna.setFieldsValue({
    antennas: nextAntennas,
  });
  readersRemoveAntenna(index);
};

export const updateAntennasByModel = async ({ modelId, accessPointOptionsReader, formAntenna, readersUpdateFormAntenna }: UpdateReaderAntennasParams): Promise<void> => {
  const selected = accessPointOptionsReader.find((item) => item.id === modelId);
  const description = selected?.description || "";

  const currentAntennas = formAntenna.getFieldValue("antennas") || [];

  const nextAntennas = currentAntennas.map((antenna: any) => ({
    ...antenna,
    modelDescription: description,
  }));

  formAntenna.setFieldsValue({
    antennas: nextAntennas,
  });

  readersUpdateFormAntenna({
    ...formAntenna.getFieldsValue(),
    antennas: nextAntennas,
  });
};
